import ScanDetails from 'features/POSRegisters/interfaces/ScanDetails';
import Alert from 'features/POSRegisters/interfaces/AlertInfo';
import {SeverityPriorityEnum} from 'features/POSRegisters/interfaces/Severity';

export default function getPriorityAlert(
  list: {
    scanResults?: Partial<ScanDetails>;
    alerts: Alert[];
  }[]
): string {
  let priorityAlert = 0;

  for (let i = 0; i < list.length; i++) {
    if (!list[i]?.alerts?.length) continue;
    else {
      const alerts = list[i].alerts;
      for (let j = 0; j < alerts.length; j++) {
        const severity = alerts[j].siteImpact.toUpperCase();
        const priority = SeverityPriorityEnum[severity];
        if (!priority) continue;
        const priorityNumber = Number(priority);
        if (priorityNumber > priorityAlert) {
          priorityAlert = priorityNumber;
        }
      }
    }
  }

  // reverse mapping to get the key name of the priority alert
  return Object.entries(SeverityPriorityEnum).find(([_, v]) => v === priorityAlert)?.[0]!;
}
